//Global External Imports
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState, Fragment, } from "react";
import { TextField, Button, Grid, Card, Box, MenuItem } from '@mui/material'
import axios from 'axios';
import { API_BASE_URL } from '../../constants/apiConstants';
import openFile from "../shared/functions/download";
//Global Internal Imports
import apiRequest from '../../functions/api';
import { useMessage } from "../../context/message-context";
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import ResponsiveDialog from '../shared/components/ResponsiveDialog'
import Formular from '../Formular/Formular';
import { FullPageSpinner } from '../lib';
//Child Imports
function FormularAusfuellen(props) {
  const { t } = useTranslation();
  //Standardfelder
  const { client, accessToken } = props;
  const [isLoading, setIsLoading] = useState(false);
  const { showErrorMessage, showSuccessMessage } = useMessage();
  const [felder, setFelder] = useState({});
  const [hper, setHper] = useState({});
  const [stammfelder, setStammfelder] = useState({})
  const [formulare, setFormulare] = useState([]);
  const [antraege, setAntraege] = useState([]);
  const [openLaden, setOpenLaden] = useState(0);
  const [openAntrag, setOpenAntrag] = useState(0);
  const [ladenFormular, setLadenFormular] = useState(0);
  const [ladenFormular2, setLadenFormular2] = useState(-1);
  const [ladenAntrag, setLadenAntrag] = useState(0);
  const [formular, setFormular] = useState("F000")
  const [formularBez, setFormularBez] = useState("")
  const [listeFormular, setListeFormular] = useState([])
  const [uebergaben, setUebergaben] = useState({})
  const [felderError, setFelderError] = useState([])
  const [files, setFiles] = useState([])
  const [loading, setLoading] = useState(false)
  //PVX Kommunikation
  useEffect(() => {
    setIsLoading(true);
    const payload = {
      "mandant": client,
      "program": "FORAUS",
      "statement": "UEBERSICHT",
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, (r) => postUebersicht(r));
    // eslint-disable-next-line
  }, [])
  useEffect(() => {
    if (ladenFormular2 >= 0) {
      LadenFormular()
    }
    // eslint-disable-next-line
  }, [ladenFormular2])
  function postUebersicht(response) {
    setIsLoading(false);
    if (response.status === 200) {
      setFelder(response.data.felder)
      setHper(response.data.hper)
      setStammfelder(response.data.stammfelder)
      if (response.data.antraege) { setAntraege(response.data.antraege); } else { setAntraege([]) }
      if (response.data.formulare) { setFormulare(response.data.formulare); } else { setFormulare([]) }
      if (response.data.uebergaben) { setUebergaben(response.data.uebergaben); } else { setUebergaben({}) }
    } else {
      if (response) {
        showErrorMessage(response.data.message)
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }

  //Standardfunktionen
  if (isLoading) {
    return <LoadingComponent path={props.location} />
  }
  //Arbeitsfunktionen
  function Reset() {
    setOpenLaden(0)
    setOpenAntrag(0)
  }
  function ChangeFelder(id, value, newfelder) {
    //setFelder(newFelder)    
    setFelder(JSON.parse(JSON.stringify(newfelder)))
  }
  function ChangeFiles(newFile) {
    var tmpliste = files
    tmpfiles.push(newFile)
    setFiles(tmpliste)
  }
  function LadenFormular() {
    if (!felder[formulare[ladenFormular].key]) return
    var inhalt = felder[formulare[ladenFormular].key][formulare[ladenFormular].key].inhalt.split(";");
    var i;
    var tmpliste = []
    for (i = 0; i < inhalt.length; i++) {
      if (inhalt[i] === "") continue
      if (!felder[formulare[ladenFormular].key][inhalt[i]] && !stammfelder[inhalt[i]]) continue
      tmpliste.push(inhalt[i])
    }
    setListeFormular(tmpliste)
    setFormular(formulare[ladenFormular].key);
    setFormularBez(formulare[ladenFormular].name);
    Reset();
  }
  function FormularSenden() {
    if (!formular || formular === "" || formular === "F000") return
    var fehler = Plausibilitaetspruefung()
    if (fehler === 1) return
  }
  function FormularSpeichern() {
    console.log(felder)
    if (!formular || formular === "F000") {
      showErrorMessage(t("Es ist kein Formular ausgewählt"))
      return
    }
    const payload = {
      "mandant": client,
      "program": "FORAUS",
      "statement": "SPEICHERN",
      "felder": felder,
      "formular": formular,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, (r) => postSpeichern(r));
  }
  function postSpeichern(response) {
    if (response.status === 200) {
      showSuccessMessage(t("Angaben gespeichert"))
    } else {
      if (response) {
        showErrorMessage(response.data.message)
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  function FormularLaden() {
    const payload = {
      "mandant": client,
      "program": "FORAUS",
      "statement": "LADEN",
      "key": antraege[ladenAntrag].key,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, (r) => postLaden(r));
  }
  function postLaden(response) {
    if (response.status === 200) {
      setFelder(response.data.felder)
      setHper(response.data.hper)
      setStammfelder(response.data.stammfelder)
      if (response.data.antraege) { setAntraege(response.data.antraege); } else { setAntraege([]) }
      if (response.data.formulare) { setFormulare(response.data.formulare); } else { setFormulare([]) }
      setLadenFormular(Number(response.data.ladenformular))
      setLadenFormular2(Number(response.data.ladenformular))
    } else {
      if (response) {
        showErrorMessage(response.data.message)
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
    setOpenAntrag(0)
  }
  function DateiLaden(key, art) {
    setLoading(true)
    const payload = {
      "mandant": client,
      "program": "FORGEN",
      "statement": "DATEI_LADEN",
      "key": key,
      "art": art,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
      "Accept": "application/pdf"
    }
    axios.post(API_BASE_URL + 'daten', payload, { headers: headers, responseType: 'blob' })
      .then((response) => {
        var fileName = 'Datei' + '.pdf';
        var contentFile = response.data;
        openFile(fileName, contentFile);
        setLoading(false)
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false)
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  }
  function Plausibilitaetspruefung() {
    var tmpError = []
    var inhalt = felder[formular][formular].inhalt
    var tmpliste = inhalt.split(";")
    tmpliste.forEach((item, index) => {
      if (item.substr(0, 1) === "S") return
      if (felder[formular][item].pflicht !== "1") return
      var typ = felder[formular][item].typ
      if (typ === "01") {
        if (!felder[formular][item].antwort || felder[formular][item].antwort === "") tmpError.push(item)
      }
      if (typ === "02") {
        if (!felder[formular][item].antwort || felder[formular][item].antwort === "") tmpError.push(item)
      }
      if (typ === "03") {
        if (!felder[formular][item].antwort || felder[formular][item].antwort === "") tmpError.push(item)
      }
      if (typ === "04") {
        if (!felder[formular][item].antwort || felder[formular][item].antwort === "") tmpError.push(item)
      }
      if (typ === "05") {
        if (!felder[formular][item].antwort || felder[formular][item].antwort === "0") tmpError.push(item)
      }
      if (typ === "06") {
        if (!felder[formular][item].antwort || felder[formular][item].antwort === "") tmpError.push(item)
      }
      if (typ === "07") {
        if (!felder[formular][item].antwort || felder[formular][item].antwort === "") tmpError.push(item)
      }
      if (typ === "08") {
        if (!felder[formular][item].antwort) {
          tmpError.push(item)
        } else {
          var check = 0
          const items = Object.values(felder[formular][item].antwort)
          items.forEach(item =>
            Object.entries(item).forEach(([key, value]) => { if (value === "1") check = 1 }
            )
          )
          if (check === 0) tmpError.push(item)
        }
      }
    })
    setFelderError(tmpError)
    if (tmpError.length > 0) {
      showErrorMessage(t("Bitte füllen Sie alle Pflichtfelder aus"))
      return 1
    } else {
      showSuccessMessage(t("Formular erfolgreich geprüft"))
      return 0
    }
  }
  //Renderfunktionen
  function renderHeader() {
    var tmpheader = ""
    if (formular !== "F000") {
      tmpheader = formular + " - " + formularBez
    } else {
      tmpheader = t("Bitte Formular auswählen")
    }
    return (
      <Fragment>
        <h2>{tmpheader}</h2>
        <hr align="center" width="100%" height="2px" />
      </Fragment>
    )
  }
  function renderLaden() {
    return (
      <ResponsiveDialog
        title={t("Formular laden")}
        open={openLaden === 1}
        setOpen={() => setOpenLaden(0)}
        actionButton={
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item>
              <Button variant="outlined" color="primary" onClick={() => Reset()}>{t("Abbrechen")}</Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" color="primary" onClick={() => LadenFormular()}>{t("Laden")}</Button>
            </Grid>
          </Grid>
        }
      >
        <Box p={2}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label={t("Formular")}
                value={ladenFormular}
                select
                onChange={(e => setLadenFormular(e.target.value))}
              >
                {formulare.map((item, index) => {
                  return (
                    <MenuItem key={index} value={index} index={index}>{item.key + " - " + item.name}</MenuItem>
                  )
                })}
              </TextField>
            </Grid>
          </Grid>
        </Box>
      </ResponsiveDialog>
    )
  }
  function renderAntrag() {
    return (
      <ResponsiveDialog
        title={t("Antrag laden")}
        open={openAntrag === 1}
        setOpen={() => setOpenAntrag(0)}
        actionButton={
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item>
              <Button variant="outlined" color="primary" onClick={() => Reset()}>{t("Abbrechen")}</Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" color="primary" onClick={() => FormularLaden()}>{t("Laden")}</Button>
            </Grid>
          </Grid>
        }
      >
        <Box p={2}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label={t("Antrag")}
                value={ladenAntrag}
                select
                onChange={(e => setLadenAntrag(e.target.value))}
              >
                {antraege && antraege.length > 0 && antraege.map((item, index) => {
                  return (
                    <MenuItem key={index} value={index} index={index}>{item.key}</MenuItem>
                  )
                })}
              </TextField>
            </Grid>
          </Grid>
        </Box>
      </ResponsiveDialog>
    )
  }
  //Rückgabe
  return (
    <Fragment>
      {renderLaden()}
      {renderAntrag()}
      <Grid container justifyContent="center" spacing={2}>
        <Grid item xs={12}>
          {renderHeader()}
        </Grid>
      </Grid>
      <Grid container justifyContent="flex-start" spacing={2}>
        <Grid item xs={12} md={2}>
          <Box p={3}>
            <Card>
              <Box p={2}>
                <Grid container justifyContent="center" spacing={2}>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => { (formulare && formulare.length > 0) ? setOpenLaden(1) : showErrorMessage(t("Es liegen keine Formulare vor")) }}
                    >
                      {t("Formular Laden")}
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => { FormularSenden() }}
                    >
                      {t("Formular prüfen")}
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => { FormularSpeichern() }}
                    >
                      {t("Antrag absenden")}
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => { (antraege && antraege.length > 0) ? setOpenAntrag(1) : showErrorMessage(t("Es liegen noch keine gespeicherten Anträge vor")) }}
                    >
                      {t("Antrag laden")}
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Card>
          </Box>
        </Grid>
        <Grid item xs={12} md={10}>

          <Formular
            key={felder[formular]}
            bez={formularBez}
            formular={formular}
            liste={listeFormular}
            felder={felder}
            stammfelder={stammfelder}
            hper={hper}
            ChangeFelder={ChangeFelder}
            uebergaben={uebergaben}
            felderError={felderError}
            ChangeFiles={ChangeFiles}
            files={files}
            DateiLaden={DateiLaden}
            client={client}
            accessToken={accessToken}
          />
        </Grid>
      </Grid>
      {loading && <FullPageSpinner />}
    </Fragment>
  )
}
export default FormularAusfuellen;
